import { RowData } from "@tanstack/react-table";
import { AppTable } from "./types/table-features";
import { Settings2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@capacit-com/lara-law-shared-ui";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { CustomColumnMeta } from "./types/custom-column-meta";
import { Tooltip, TooltipContent, TooltipTrigger } from "@capacit-com/lara-law-shared-ui";

interface DataTableViewOptionsProps<TData extends RowData> {
  table: AppTable<TData>;
}

export function DataTableViewOptions<TData extends RowData>({
  table,
}: DataTableViewOptionsProps<TData>) {
  return (
    <DropdownMenu>
      {/* Icon-only button for small screens with tooltip */}
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="icon" className="h-8 w-8 lg:hidden">
              <Settings2 className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent>
          <p>Kolonner</p>
        </TooltipContent>
      </Tooltip>

      {/* Button with text for large screens */}
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="hidden h-8 lg:flex">
          <Settings2 />
          Kolonner
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-[150px]">
        <DropdownMenuLabel>Vis/skjul kolonner</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {table
          .getAllColumns()
          .filter(
            (column) =>
              typeof column.accessorFn !== "undefined" && column.getCanHide()
          )
          .map((column) => {
            const headerTitle =
              typeof column.columnDef.header === "string"
                ? column.columnDef.header
                : (column.columnDef.meta as CustomColumnMeta)?.displayName ||
                  column.id;
            return (
              <DropdownMenuCheckboxItem
                key={column.id}
                className="capitalize"
                checked={column.getIsVisible()}
                onCheckedChange={(value) => {
                  column.toggleVisibility(!!value);
                }}
                onSelect={(event) => {
                  event.preventDefault();
                }}
              >
                {headerTitle}
              </DropdownMenuCheckboxItem>
            );
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
